import * as actions from './actions'
import { HybridSettingsState } from './model';
import { SettingsHybridActions } from './actions'

const initialState: HybridSettingsState = <HybridSettingsState> {
    isLoading: true
};

const reducer = (state: HybridSettingsState = initialState, action: SettingsHybridActions): HybridSettingsState => {
  switch (action.type) {
    case actions.Loading:
      return {
        ...state,
        isLoading: true
      };

    case actions.ChangeSelectedServer:
      return {
        ...state,
        selectedServer: action.payload.selectedServer
      };
    case actions.ChangeSelectedServerGroup:
      return {
       ...state,
       selectedServerGroup: action.payload.selectedServerGroup
    };

    case actions.FetchServers:
      return {
        ...state,
        serversLoading: true
      };

    case actions.ChangeServers:
      return {
        ...state,
        serversLoading: false,
        servers: action.payload.servers
      };

    case actions.ChangeAgentInstallerUrl:
      return {
          ...state,
          amZipUrl: action.payload.publicUrl
      };
    default:
      return state
  }
};

export default reducer
